import React from 'react';
import { FileText, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface DocumentTransformOverlayProps {
  isVisible: boolean;
  onTransform: () => void;
  onDismiss: () => void;
  isTransferring?: boolean;
}

const DocumentTransformOverlay: React.FC<DocumentTransformOverlayProps> = ({
  isVisible,
  onTransform,
  onDismiss,
  isTransferring = false
}) => {
  if (!isVisible) return null;

  return (
    <div className={cn(
      "fixed inset-0 bg-black/50 backdrop-blur-sm z-50",
      "flex items-center justify-center min-h-screen p-4",
      "animate-fade-in"
    )}>
      <div className="bg-background rounded-xl shadow-2xl max-w-md w-full p-6 relative">
        {/* Botão X para fechar */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onDismiss}
          className="absolute top-2 right-2 h-6 w-6 rounded-full hover:bg-muted"
          aria-label="Fechar overlay"
        >
          <X className="h-4 w-4" />
        </Button>

        {/* Conteúdo principal */}
        <div className="flex flex-col items-center gap-4 text-center pt-2">
          <div className="rounded-full bg-primary/10 p-4">
            <FileText className="h-8 w-8 text-primary" />
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-1">
              Transformar em Documento
            </h3>
            <p className="text-sm text-muted-foreground">
              Este conteúdo pode ser convertido em um documento editável
            </p>
          </div>

          <Button
            onClick={onTransform}
            disabled={isTransferring}
            className="px-6 py-2 font-medium"
          >
            {isTransferring ? "Criando..." : "Transformar em Documento"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentTransformOverlay;